enum ModalType {
    ADD = 'add',
    EDIT = 'edit',
    DELETE = 'delete',
    NULL = '',
}

// item of news list
interface INews {
    _id: string;
    validFrom: string;
    validTo: string;
    title: string;
    content: string;
    createdAt: string;
    updatedAt?: string; // old data doesn't have this field
    updatedBy?: string; // old data doesn't have this field
}

// data for news modal (add, edit)
interface INewsModalData {
    _id?: string;
    validFrom: string;
    validTo: string;
    title: string;
    content: string;
}

interface INewsState {
    /** keyword for searching  */
    keyword: string
    /** list of news */
    newsList: INews[],
    /** empty news modal template */
    emptyNewsModal: INewsModalData,
    /** flag to determine if modal is shown or not */
    isShowModal: boolean,
    /** modal type. 'add' | 'edit' | 'delete' | '' */
    modalType: ModalType,
}



export type { INews, INewsState, INewsModalData };
export { ModalType };
